module.exports = __webpack_public_path__ + "static/other-accounts-8e56274b48adf5dc97882334925bbea8.mp4";